import { render, staticRenderFns } from "./dnser.vue?vue&type=template&id=c8e0ab0e&"
import script from "./dnser.vue?vue&type=script&lang=js&"
export * from "./dnser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports